import { BookingProposalItem } from 'noddi-types';
import { NoddiBasicCard } from 'noddi-ui-web';
import { getCarDisplayName } from 'noddi-util';
import { NoddiCarSvg } from '../Home/CarSvg';
import { TireQuoteAttachedToItem } from './TireQuoteAttachedToItem';

interface ProposalSummaryProps {
  bookingProposalItems: BookingProposalItem[];
}

export const ProposalSummary = ({ bookingProposalItems }: ProposalSummaryProps) => {
  return (
    <>
      {bookingProposalItems.map((bookingProposalItem) => (
        <NoddiBasicCard key={bookingProposalItem.id} className='flex flex-col gap-1 bg-lightPurple/50 shadow-none'>
          <div className='flex items-center justify-between gap-4'>
            <h1 className='font-semibold'>{getCarDisplayName(bookingProposalItem.car)}</h1>
            <NoddiCarSvg scale={0.5} />
          </div>

          <div className='flex flex-col'>
            {bookingProposalItem.salesItems.map(({ item: { name } }) => (
              <p key={name}>{name}</p>
            ))}
            {bookingProposalItem.tireQuote && <TireQuoteAttachedToItem slug={bookingProposalItem.tireQuote.slug} />}
          </div>
        </NoddiBasicCard>
      ))}
    </>
  );
};
